export const NOTIFICATION_CODE = Object.freeze({
  EMOTION_CHECKIN: 'EMOTION_CHECKIN',
  MEDICATION_REMINDER: 'MEDICATION_REMINDER',
});

export const NOTIFICATION_ACTION = Object.freeze({
  ACKNOWLEDGED: 'ACKNOWLEDGED',
  DISMISSED: 'DISMISSED',
  TAKEN: 'TAKEN',
  SKIPPED: 'SKIPPED',
  SNOOZED: 'SNOOZED',
  FULFILLED: 'FULFILLED',
  CANCELLED: 'CANCELLED',
});

export const MEDICATION_NOTIFICATION_ACTION = Object.freeze({
  TAKEN: NOTIFICATION_ACTION.TAKEN,
  SKIPPED: NOTIFICATION_ACTION.SKIPPED,
  SNOOZED: NOTIFICATION_ACTION.SNOOZED,
});

export const NOTIFICATION_STATE = Object.freeze({
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
});
